import { render, staticRenderFns } from "./appraisalStudentList.vue?vue&type=template&id=dba647de"
import script from "./appraisalStudentList.vue?vue&type=script&lang=js"
export * from "./appraisalStudentList.vue?vue&type=script&lang=js"
import style0 from "./appraisalStudentList.vue?vue&type=style&index=0&id=dba647de&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports